/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rules mismatch: expiry date greater than or equal to
 * @export
 * @interface PaxCheckExpiryDateGteMismatch
 */
export interface PaxCheckExpiryDateGteMismatch {
    /**
     * What was expected
     * @type {Date}
     * @memberof PaxCheckExpiryDateGteMismatch
     */
    expected: Date;
    /**
     * What was provided
     * @type {Date}
     * @memberof PaxCheckExpiryDateGteMismatch
     */
    actual: Date;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckExpiryDateGteMismatch
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckExpiryDateGteMismatch interface.
 */
export function instanceOfPaxCheckExpiryDateGteMismatch(value: object): value is PaxCheckExpiryDateGteMismatch {
    if (!('expected' in value) || value['expected'] === undefined) return false;
    if (!('actual' in value) || value['actual'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckExpiryDateGteMismatchFromJSON(json: any): PaxCheckExpiryDateGteMismatch {
    return PaxCheckExpiryDateGteMismatchFromJSONTyped(json, false);
}

export function PaxCheckExpiryDateGteMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckExpiryDateGteMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'expected': (new Date(json['expected'])),
        'actual': (new Date(json['actual'])),
        'type': json['type'],
    };
}

export function PaxCheckExpiryDateGteMismatchToJSON(json: any): PaxCheckExpiryDateGteMismatch {
    return PaxCheckExpiryDateGteMismatchToJSONTyped(json, false);
}

export function PaxCheckExpiryDateGteMismatchToJSONTyped(value?: PaxCheckExpiryDateGteMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected': ((value['expected']).toISOString().substring(0,10)),
        'actual': ((value['actual']).toISOString().substring(0,10)),
        'type': value['type'],
    };
}

